var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"btn",class:{
    active: _vm.active,
    'btn-primary': _vm.primary,
    'btn-secondary': _vm.secondary,
    'btn-danger': _vm.danger,
    'btn-danger-text': _vm.dangerText,
    'btn-cta': _vm.cta,
    'btn-block': _vm.block,
    'btn-sm': _vm.sm,
    'btn-xs': _vm.xs,
    'btn-form': _vm.form,
    'btn-nav': _vm.nav,
    'btn-pill': _vm.pill,
    'btn-dropdown': _vm.dropdown,
    'btn-max-width': _vm.maxWidth,
  },attrs:{"type":_vm.tag === 'button' ? 'button' : undefined,"href":_vm.href},on:{"click":_vm.onClick,"touchstart":_vm.onTouchStart,"mousedown":_vm.onTouchStart}},[_vm._t("default"),(_vm.dropdown)?[_c('svg',{staticClass:"bi bi-caret-down-fill",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"9","fill":"currentColor","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"}})])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }